module.exports = __webpack_public_path__ + "img/photo_2022-10-26_22-37-34.ccd91891.jpg";